import _ from "lodash";

export const removeUndefinedProperties = <T>(obj: T): T => {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === "object") {
        removeUndefinedProperties(obj[key]);
      } else if (obj[key] === undefined) {
        delete obj[key];
      }
    });
  }
  return obj;
};

export const removeNullProperties = <T>(obj: T): T =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {} as T);

export const deepOmit = (obj, propertiesToOmit) => {
  if (_.isArray(obj)) {
    return obj.map((item) => deepOmit(item, propertiesToOmit));
  } else if (_.isObject(obj)) {
    return _.omitBy(
      _.mapValues(obj, (value) => deepOmit(value, propertiesToOmit)),
      (value, key) => propertiesToOmit.includes(key)
    );
  }
  return obj;
};
